import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { hours } from "../../utils";
import { Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

const MotionGrid = motion(Grid);

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function DaysTabs({
  days,
  selectHour,
  selectedHour,
  setValue,
  value,
  currentTotalSchedules,
}) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { currentArr } = React.useMemo(() => {
    const currentArr = selectedHour.find((day) => day.id === value)?.hours;

    return {
      currentArr,
    };
  }, [value, selectedHour]);

  const handleAddHour = (newValue) => {
    const newArr = selectedHour.map((day) => {
      if (day.id === value) {
        if (day.hours?.includes(newValue)) {
          day.hours = day.hours.filter((hour) => hour !== newValue);
        } else {
          day.hours = [...day.hours, newValue];
        }
        return day;
      }
      return day;
    });

    selectHour(newArr);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "#e9e9e970",
        display: "flex",
        height: 208,
        borderRadius: 2,
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: "divider", minWidth: 100 }}
      >
        {days.map((d) => (
          <Tab key={d.id} label={d.name} value={d.id} {...a11yProps(d.id)} />
        ))}
      </Tabs>

      <Box sx={{ p: 1 }}>
        <Grid container>
          {hours.map((h, idx) => (
            <MotionGrid
              whileTap={{ scale: 0.8 }}
              whileHover={{ scale: 1.07 }}
              initial={{ y: -5, opacity: 0 }}
              animate={{
                y: 0,
                opacity: 1,
                transition: { type: "just", mass: 0.5, delay: idx * 0.02 },
              }}
              key={idx}
              display="flex"
              sx={{
                fontWeight: currentArr?.includes(h) ? 500 : 400,
                borderRadius: 2.5,
                cursor: "pointer",
                p: 0.5,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: currentArr?.includes(h) && "#008c23",
                color: currentArr?.includes(h) && "#FFF",
                "&:hover": {
                  bgcolor: currentArr?.includes(h) ? "#008c23" : "#e6e6e670",
                },
              }}
              item
              xs={1.5}
              onClick={() => handleAddHour(h)}
            >
              {h}
            </MotionGrid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
